import { createRoutine } from 'redux-saga-routines';

import {
  ADD_USER_PHONE,
  CHECK_UPDATE_PASSWORD_KEY,
  CLEAN_AGGREGATIONS,
  CLEAR_PROFILES_LIST,
  CLEAR_COMPANIES,
  CRUD_GET_LIST,
  CRUD_GET_ONE,
  CRUD_GET_WHOLE_LIST,
  ENQUEUE_SNACKBAR,
  GET_ACTIVE_PROFILE,
  GET_AGENCIES,
  CLEAR_AGENCIES,
  GET_AGGREGATIONS,
  GET_ARTIST_PROFESSIONS,
  GET_COMMON_USER_DATA,
  GET_COMPANIES,
  GET_PROFILES_LIST,
  LOGIN_USER,
  LOGOUT,
  REMOVE_SNACKBAR,
  RESET_PASSWORD,
  SET_ACTIVE_PROFILE,
  SET_USER_DATA,
  SET_USER_PROFILES,
  UPDATE_PASSWORD,
  UPDATE_USER_DATA,
  CRUD_UPDATE_ONE,
  CRUD_CREATE,
  SET_START_AGGREGATIONS,
  GET_USER_PERMISSIONS,
  CRUD_DELETE,
  GET_PROFILE_PERMISSIONS,
  GET_ARTIST_VOICE_TYPES,
  IDENTIFY_USER_ON_LOGIN,
  RESET_RESET_PASSWORD,
  DELETE_USER_PHONE,
  GET_CITIES,
  RESET_CITIES,
  GET_VENUES,
  RESET_VENUES,
  GET_SETTINGS,
  GET_STAGES,
  USE_BUFFER_VALUE,
  GET_WORK_TYPES,
  GET_WORK_STYLES,
  GET_PRIVACY_OPTIONS,
  GET_AOS_PROFESSIONS,
  SET_NOTIFICATION_BANNER,
  GET_LANGUAGES,
  GET_DYNAMIC_COUNTRIES,
} from './constants';

export const loginUser = createRoutine(LOGIN_USER);
export const logoutAction = createRoutine(LOGOUT);
export const getUserPermissionsAction = createRoutine(GET_USER_PERMISSIONS);
export const getProfilePermissionsAction = createRoutine(GET_PROFILE_PERMISSIONS);
export const setUserData = createRoutine(SET_USER_DATA);
export const setUserProfiles = createRoutine(SET_USER_PROFILES);
export const getCommonUserData = createRoutine(GET_COMMON_USER_DATA);
export const updateUserData = createRoutine(UPDATE_USER_DATA);
export const addUserPhone = createRoutine(ADD_USER_PHONE);
export const deleteUserPhone = createRoutine(DELETE_USER_PHONE);
export const getActiveProfileAction = createRoutine(GET_ACTIVE_PROFILE);
export const setActiveProfileAction = createRoutine(SET_ACTIVE_PROFILE);
export const resetPasswordAction = createRoutine(RESET_PASSWORD);
export const resetResetPasswordAction = createRoutine(RESET_RESET_PASSWORD);
export const updatePasswordAction = createRoutine(UPDATE_PASSWORD);
export const checkUpdatePasswordKeyAction = createRoutine(CHECK_UPDATE_PASSWORD_KEY);

export const setStartAggregationAction = createRoutine(SET_START_AGGREGATIONS);
export const getAggregationsAction = createRoutine(GET_AGGREGATIONS);
export const cleanAggregationsAction = createRoutine(CLEAN_AGGREGATIONS);
export const getArtistProfessionsAction = createRoutine(GET_ARTIST_PROFESSIONS);
export const getArtistVoiceTypesAction = createRoutine(GET_ARTIST_VOICE_TYPES);
export const getAgenciesAction = createRoutine(GET_AGENCIES);
export const clearAgenciesAction = createRoutine(CLEAR_AGENCIES);
export const getCompaniesAction = createRoutine(GET_COMPANIES);
export const clearCompaniesAction = createRoutine(CLEAR_COMPANIES);
export const getProfilesAction = createRoutine(GET_PROFILES_LIST);
export const clearProfilesAction = createRoutine(CLEAR_PROFILES_LIST);

export const getList = createRoutine(CRUD_GET_LIST);
export const getWholeList = createRoutine(CRUD_GET_WHOLE_LIST);
export const getOne = createRoutine(CRUD_GET_ONE);
export const updateOne = createRoutine(CRUD_UPDATE_ONE);
export const createEntity = createRoutine(CRUD_CREATE);
export const deleteEntity = createRoutine(CRUD_DELETE);

export const enqueueSnackbarAction = createRoutine(ENQUEUE_SNACKBAR);
export const removeSnackbarAction = createRoutine(REMOVE_SNACKBAR);

export const userIdentifyAction = createRoutine(IDENTIFY_USER_ON_LOGIN);
export const getCitiesAction = createRoutine(GET_CITIES);
export const resetCitiesAction = createRoutine(RESET_CITIES);
export const getVenuesAction = createRoutine(GET_VENUES);
export const resetVenuesAction = createRoutine(RESET_VENUES);
export const getStagesAction = createRoutine(GET_STAGES);

export const getSettings = createRoutine(GET_SETTINGS);

export const useBufferValueAction = createRoutine(USE_BUFFER_VALUE);
export const getWorkTypesAction = createRoutine(GET_WORK_TYPES);
export const getWorkStylesAction = createRoutine(GET_WORK_STYLES);
export const getPrivacyOptionsAction = createRoutine(GET_PRIVACY_OPTIONS);
export const getAOSProfessionsAction = createRoutine(GET_AOS_PROFESSIONS);

export const setNotificationBanner = createRoutine(SET_NOTIFICATION_BANNER);
export const getLanguagesAction = createRoutine(GET_LANGUAGES);
export const getDynamicCountriesAction = createRoutine(GET_DYNAMIC_COUNTRIES);
